export const FIELD_STYLE_INFO_TILE = "FIELD_STYLE_INFO_TILE";
export const FIELD_STYLE_SUMMARY = "FIELD_STYLE_SUMMARY";
export const FIELD_STYLE_INQUIRY_DETAILS = "FIELD_STYLE_INQUIRY_DETAILS";
